<script>
import forminput from "../formcomponet/forminput.vue";
import formtextarea from "../formcomponet/formtextarea.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import configtranslations from "@/models/configtranslations";

export default {
  mixins: [apibtoast, apigeneric, configtranslations],
  props: ["DataId", "LanId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      AddEdit: null,
      FormData: {},
      languages: {},
      LinkTranslationsData: [],
    };
  },
  components: {
    Loader,
    forminput,
    formtextarea,
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("configtranslations", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
            }
          });
        } else {
          this.Update("configtranslations", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
            }
          });
        }
      }
    },
    Get() {
      this.ActionsFilterGet({
        Service: "configtranslations",
        Page: this.Page,
        Filter: "&Langid=" + this.LanId + "&Configid=" + this.DataId,
      }).then((res) => {
        if (res.Data.length > 0) {
          this.FormData = res.Data[0];
          this.AddEdit = "Edit";
        } else {
          this.FormData = this.configtranslationsData;
          this.AddEdit = "Add";
          this.FormData.Langid = this.LanId;
          this.FormData.Configid = this.DataId; 
           this.FormData.Websiteid = this.GettersWebsiteid 
        }
      });
    },
  },
};
</script>
<template>
  <Loader>
    <Form @submit.prevent="onSubmit">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-4">
            {{ $t("configs.AddEdit.SeoAyarlari.Title") }}
          </h4>
          <div class="row mb-2">
            <div class="col-sm-12">
              <forminput
                :FormDataType="FormDataType.Sitebaslik"
                :Value="FormData.Sitebaslik"
                :v="$v.FormData.Sitebaslik"
                @input="FormData.Sitebaslik = $event"
              />
              <forminput
                :FormDataType="FormDataType.Siteanahtarkelimeler"
                :Value="FormData.Siteanahtarkelimeler"
                :v="$v.FormData.Siteanahtarkelimeler"
                @input="FormData.Siteanahtarkelimeler = $event"
              />
              <formtextarea
                :FormDataType="FormDataType.Siteaciklama"
                :Value="FormData.Siteaciklama"
                :v="$v.FormData.Siteaciklama"
                @input="FormData.Siteaciklama = $event"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-4">
            {{ $t("configs.AddEdit.IletisimBilgileri.Title") }}
          </h4>
          <div class="row mb-2">
            <div class="col-sm-12">
              <formtextarea
                :FormDataType="FormDataType.Contactaddress"
                :Value="FormData.Contactaddress"
                :v="$v.FormData.Contactaddress"
                @input="FormData.Contactaddress = $event"
              />
              <forminput
                :FormDataType="FormDataType.Contactphone"
                :Value="FormData.Contactphone"
                :v="$v.FormData.Contactphone"
                @input="FormData.Contactphone = $event"
              />
              <forminput
                :FormDataType="FormDataType.Contactfax"
                :Value="FormData.Contactfax"
                :v="$v.FormData.Contactfax"
                @input="FormData.Contactfax = $event"
              />
              <forminput
                :FormDataType="FormDataType.Contactemail"
                :Value="FormData.Contactemail"
                :v="$v.FormData.Contactemail"
                @input="FormData.Contactemail = $event"
              />
              <formtextarea
                :FormDataType="FormDataType.Contactmap"
                :Value="FormData.Contactmap"
                :v="$v.FormData.Contactmap"
                @input="FormData.Contactmap = $event"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-4">
            {{ $t("configs.AddEdit.Gorseller.Title") }}
          </h4>
          <div class="row mb-2">
            <div class="col-sm-12">
              <b-form-group
                id="example text"
                :label="FormDataType.Sitelogo.FieldTitle"
                label-for="text"
                class="mb-3"
              >
                <span>{{ FormData.Sitelogo }}</span>
                <input
                  class="form-control"
                  ref="Sitelogo"
                  type="file"
                  v-on:change="FileUpload('Sitelogo')"
                  id="FormData.Sitelogo"
                  accept=".jpg, .jpeg, .png "
                />
              </b-form-group>
              <formtextarea
                :FormDataType="FormDataType.Introductionvideo"
                :Value="FormData.Introductionvideo"
                :v="$v.FormData.Introductionvideo"
                @input="FormData.Introductionvideo = $event"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">
                      {{ $t("configs.AddEdit.Kvkk.Title") }}
                    </h4>
                    <div class="row mb-2">
                      <div class="col-sm-12">  
                        
                        <formtextarea
                          :FormDataType="FormDataType.Kvkkmetni"
                          :Value="FormData.Kvkkmetni"
                          :v="$v.FormData.Kvkkmetni"
                          @input="FormData.Kvkkmetni = $event"
                        />
                          
                     
              <button class="btn btn-primary" type="submit">
                {{ $t("dpagecategories.AddEdit.Button") }}
              </button>
                      </div>
                    </div>
                  </div>
                </div>
    </Form>
  </Loader>
</template>
